import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import type moment from 'moment'

import { observer } from 'mobx-react'

import { useEffect } from 'modules/core/hooks/useEffect'
import { dateToString } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import { useSchedule } from 'modules/shift_management/hooks/useSchedule'
import Holidays from 'modules/shift_management/store/internal/collections/Holidays'
import Leaves from 'modules/shift_management/store/internal/collections/Leaves'
import RestDays from 'modules/shift_management/store/internal/collections/RestDays'

import DayItem from './DayItem'

export interface Props {
  selectedDate: moment.Moment
}

interface ResultRefs {
  [key: string]: HTMLDivElement | null
}

const Content = ({ selectedDate }: Props) => {
  const [{ view, leaves, holidays, restDays }] = useSchedule()
  const dateRefs = React.useRef<ResultRefs>({})
  const formattedDate = dateToString(selectedDate, 'ui')

  useEffect(() => {
    dateRefs.current[formattedDate]?.scrollIntoView({ behavior: 'smooth' })
  }, [formattedDate])

  return (
    <Box gap="s40">
      <Box gap="s8">
        <Text.Header2>{view.headerTitle}</Text.Header2>
        <Text.Normal size="300">{i18n.t('shift_management.sidepanel.subtitle')}</Text.Normal>
      </Box>
      <Box gapDivider gap="s24">
        {view.dates.map((date: moment.Moment) => (
          <Box
            key={dateToString(date, 'ui')}
            ref={(node: HTMLDivElement) => (dateRefs.current[dateToString(date, 'ui')] = node)}
          >
            <DayItem
              date={date}
              leaves={leaves ? new Leaves(leaves.filterByDate(date)) : new Leaves([])}
              holidays={holidays ? new Holidays(holidays.filterByDate(date)) : new Holidays([])}
              restDays={
                restDays ? new RestDays(restDays.filterPublishedByDate(date)) : new RestDays([])
              }
            />
          </Box>
        ))}
      </Box>
    </Box>
  )
}

export default observer(Content)
